import { render, staticRenderFns } from "./ProductDrawer.vue?vue&type=template&id=70073d1b&scoped=true&"
import script from "./ProductDrawer.vue?vue&type=script&lang=js&"
export * from "./ProductDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProductDrawer.vue?vue&type=style&index=0&id=70073d1b&prod&lang=sass&scoped=true&"
import style1 from "./ProductDrawer.vue?vue&type=style&index=1&id=70073d1b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70073d1b",
  null
  
)

export default component.exports